import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
// 👉 Custom Arrow Components
const NextArrow = ({ onClick }) => (
  <div
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      height:"60px",
      width:"20px",
      background:"#ffff",
      transform: "translateY(-50%)",
      fontSize: "2rem",
      zIndex: 2,
      cursor: "pointer",
      color: "black",
      display:"flex",
      alignItems:"center",
      justifyContent:"center",
      borderRadius:"6px",
      padding:"15px"
    }}
    onClick={onClick}
  >
 <img src="https://www.iconpacks.net/icons/2/free-arrow-right-icon-3098-thumb.png" style={{width:"30px"}} />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
         height:"60px",
      width:"20px",
      background:"#ffff",
      transform: "translateY(-50%)",
      fontSize: "2rem",
      zIndex: 2,
      cursor: "pointer",
      color: "black",
        display:"flex",
      alignItems:"center",
      justifyContent:"center",
      borderRadius:"6px",
      padding:"15px"
    }}
    onClick={onClick}
  >
<img src="https://www.iconpacks.net/icons/2/free-arrow-left-icon-3099-thumb.png" style={{width:"30px"}} />
  </div>
);

const ImageCarousel = ({list}) => {
  const images =list?.length>0 ? list?.map((item,index)=>item?.image) : []
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
  arrows: true,

         nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
     responsive: [
    {
      breakpoint: 1200, // large screens
      settings: {
  arrows: true,

         nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
      },
    },
    {
      breakpoint: 992, // tablets
      settings: {
  arrows: true,

         nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
      },
    },
    {
      breakpoint: 768, // landscape mobile
      settings: {
        arrows: false,
        centerMode: false,
      },
    },
    {
      breakpoint: 480, // portrait mobile
      settings: {
        arrows: false,
        centerMode: false,
      },
    },
  ],

  };

  return (
    <>
    <style>{`
  /* Base carousel container */
  .carousel-container {
    width: 100%;
    overflow: hidden;
    background: #f6f6f6;
  }

  /* Default image style */
  .carousel-image {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
  }

  /* =======================
     DESKTOP (FIX BIG SIZE)
  ======================= */
  @media (min-width: 992px) {
    .carousel-container {
      max-height: 560px;
    }

    .carousel-image {
    object-fit: cover;
      max-height: 560px;
      margin: 0 auto;
    }
  }

  /* =======================
     TABLET
  ======================= */
  @media (max-width: 991px) and (min-width: 577px) {
    .carousel-container {
      max-height: 340px;
    }

    .carousel-image {
      max-height: 340px;
    }
  }

  /* =======================
     MOBILE (KEEP AS IS)
  ======================= */
  @media (max-width: 576px) {
    .carousel-container {
      max-height: 240px;
    }

    .carousel-image {
      max-height: 240px;
    }
  }

  /* Slick dots positioning */
  .slick-dots {
    bottom: 10px;
  }
`}</style>
 
    <div className="carousel-container">
      <Slider {...settings}>
        {images?.length>0 ? images.map((src, idx) => (
          <div key={idx}>
            <img src={src} alt={`slide-${idx}`} className="carousel-image" />
          </div>
        )) : <>Loading...</>}
      </Slider>
    </div>
    </>
  );
};

export default ImageCarousel;
